import { PaymentMethodType } from './payment.js';

var ApplePayStatus;
(function (ApplePayStatus) {
    ApplePayStatus[ApplePayStatus["Initial"] = 0] = "Initial";
    ApplePayStatus[ApplePayStatus["Cancelled"] = 1] = "Cancelled";
    ApplePayStatus[ApplePayStatus["PaymentAuthorized"] = 2] = "PaymentAuthorized";
    ApplePayStatus[ApplePayStatus["SessionInitialized"] = 3] = "SessionInitialized";
    ApplePayStatus[ApplePayStatus["Error"] = 4] = "Error";
    ApplePayStatus[ApplePayStatus["PaymentSuccess"] = 5] = "PaymentSuccess";
})(ApplePayStatus || (ApplePayStatus = {}));
var ApplePayError;
(function (ApplePayError) {
    ApplePayError[ApplePayError["SessionInitializationFailed"] = 0] = "SessionInitializationFailed";
    ApplePayError[ApplePayError["BeginningSessionFailed"] = 1] = "BeginningSessionFailed";
    ApplePayError[ApplePayError["InvalidCardType"] = 2] = "InvalidCardType";
    ApplePayError[ApplePayError["MerchantValidationFailed"] = 3] = "MerchantValidationFailed";
    ApplePayError[ApplePayError["PaymentRejected"] = 4] = "PaymentRejected";
    ApplePayError[ApplePayError["UnknownError"] = 5] = "UnknownError";
    ApplePayError[ApplePayError["GetRoutingKeyFailed"] = 6] = "GetRoutingKeyFailed";
})(ApplePayError || (ApplePayError = {}));
var isApplePay = function (paymentMethod) { return paymentMethod === PaymentMethodType.APPLE_PAY; };
var isPaymentsSourceCaptureApiError = function (e) { var _a; return typeof ((_a = e === null || e === void 0 ? void 0 : e.error) === null || _a === void 0 ? void 0 : _a.code) === 'string'; };

export { ApplePayError, ApplePayStatus, isApplePay, isPaymentsSourceCaptureApiError };
